import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ScrollToTop } from './components/layout/scrollTop/scrollToTop'

import Main from './containers/main'
import MakeClaim from './containers/makeClaim'
import UploadDocument from './containers/uploadId'
import SignDocuments from './containers/signDocuments'
import MakeClaimIL from './containers/makeClaimIL'
import SignDocumentsIL from './containers/signDocumentIL'
import UploadDocumentIL from './containers/uploadIdIL'
import MakeClaimMailRefferal from './containers/makeClaimMailReferrel'
import Thankyou from './containers/thankyou'

const LEAD_ORIGIN_SNTLEGACY = 'webform_SENTINEL_ORIGINAL'
const LEAD_ORIGIN_SNT = 'webform_SENTINEL_ALTERNATE'
const LEAD_ORIGIN_MR = 'webform_SENTINEL_MAILREFERRAL'
export default function AppRouter() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Main />}>
                    <Route path="/" element={<MakeClaim />} />
                    <Route path="start" element={<MakeClaim />} />
                    <Route path="register" element={<MakeClaimMailRefferal />} />
                    <Route path="claim" element={<MakeClaimMailRefferal />} />
                    <Route path="thankyou" element={<Thankyou />} />
                    <Route path="start/thankyou" element={<Thankyou />} />
                    <Route
                        path="sign-sentinel-cfa/:token"
                        element={<SignDocuments docsToSign={LEAD_ORIGIN_SNTLEGACY} />}
                    />
                    <Route path="sign/:token" element={<SignDocuments docsToSign={LEAD_ORIGIN_SNT} />} />
                    <Route path="upload-id/:token" element={<UploadDocument origin={LEAD_ORIGIN_SNT} />} />
                    <Route path="upload-id-mr/:token" element={<UploadDocument origin={LEAD_ORIGIN_MR} />} />
                    <Route path="irresponsible-lending">
                        <Route path="start" element={<MakeClaimIL />} />
                        <Route
                            path="sign-sentinel-ul-cfa/:token"
                            element={<SignDocumentsIL docsToSign="sentinel-il-cfa" />}
                        />
                        <Route path="upload-id/:token" element={<UploadDocumentIL />} />
                    </Route>
                </Route>
            </Routes>
        </Router>
    )
}
